import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Star: React.FC<IconComponentProps> = ({
  className,
  strokeWidth = '1.5',
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#star-16)">
      <path
        d="M8.54352 1.33794L10.2599 4.80302C10.2989 4.89098 10.3603 4.96716 10.438 5.02398C10.5156 5.0808 10.6068 5.11627 10.7025 5.12686L14.4914 5.68819C14.6011 5.7023 14.7045 5.74732 14.7896 5.818C14.8746 5.88869 14.9379 5.98213 14.9719 6.08739C15.0058 6.19265 15.0091 6.30542 14.9814 6.41249C14.9536 6.51957 14.896 6.61654 14.8153 6.69209L12.0842 9.40155C12.0145 9.46667 11.9621 9.5482 11.932 9.63869C11.9019 9.72918 11.8948 9.82578 11.9115 9.91969L12.57 13.7302C12.589 13.8397 12.577 13.9524 12.5352 14.0553C12.4933 14.1583 12.4235 14.2475 12.3336 14.3127C12.2435 14.378 12.1371 14.4166 12.0261 14.4243C11.9153 14.4321 11.8045 14.4084 11.7064 14.3563L8.29525 12.5536C8.20791 12.5107 8.11189 12.4884 8.01459 12.4884C7.91728 12.4884 7.82127 12.5107 7.73392 12.5536L4.32281 14.3563C4.22468 14.4084 4.11387 14.4321 4.003 14.4243C3.89213 14.4166 3.78564 14.378 3.69566 14.3127C3.60568 14.2475 3.53582 14.1583 3.49402 14.0553C3.45222 13.9524 3.44018 13.8397 3.45924 13.7302L4.11771 9.87651C4.1344 9.7826 4.12734 9.686 4.09718 9.59551C4.06701 9.50502 4.0147 9.42349 3.945 9.35837L1.18157 6.69209C1.09981 6.61448 1.04232 6.51482 1.01605 6.40519C0.989777 6.29556 0.995861 6.18066 1.03356 6.07442C1.07126 5.96818 1.13896 5.87515 1.22845 5.80659C1.31795 5.73805 1.4254 5.69692 1.53779 5.68819L5.32672 5.12686C5.42236 5.11627 5.51355 5.0808 5.59121 5.02398C5.66885 4.96716 5.73026 4.89098 5.7693 4.80302L7.48565 1.33794C7.53239 1.23702 7.60702 1.15158 7.70075 1.0917C7.79447 1.03182 7.90337 1 8.01459 1C8.1258 1 8.2347 1.03182 8.32843 1.0917C8.42215 1.15158 8.49678 1.23702 8.54352 1.33794Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="star-16">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
